import React from 'react';
import WhatIfTreeGridContainer from '../containers/WhatIfTreeGridContainer';

class WhatIfPres extends React.Component {
  render() {
    const { results } = this.props;

    return (
      <div style={{ marginBottom: '25px', height: '100%' }}>
        <WhatIfTreeGridContainer data={results} />
      </div>
    );
  }
}

export default WhatIfPres;
